import { useProductFeatures } from 'bundles/enroll-common/utils/productFeatureFlags';
import { IdTypes } from 'bundles/product-features';

export const useIsPartnerSupportedAccessEnabled = (courseId?: string) => {
  const { features, loading } = useProductFeatures({
    idType: IdTypes.Course,
    id: courseId!,
    skip: !courseId,
    ssr: true,
  });

  const isPartnerSupportedAccessEnabled = features.get('globalPayments', 'enablePartnerSupportedAccess');

  return !loading && isPartnerSupportedAccessEnabled;
};
